import React from 'react';
import { motion } from 'framer-motion';
import { BuildingIcon, TargetIcon, UsersIcon, CalculatorIcon, TrendingUpIcon, TruckIcon, HeartHandshakeIcon, LandmarkIcon } from 'lucide-react';
const modules = [{
  icon: <BuildingIcon className="w-6 h-6 text-primary" data-id="element-66" />,
  title: 'Introducción a la Administración',
  desc: 'Conceptos básicos, evolución histórica y el rol del administrador.'
}, {
  icon: <TargetIcon className="w-6 h-6 text-primary" data-id="element-67" />,
  title: 'Estrategia Empresarial',
  desc: 'Planificación estratégica, análisis FODA y ventaja competitiva.'
}, {
  icon: <UsersIcon className="w-6 h-6 text-primary" data-id="element-68" />,
  title: 'Recursos Humanos',
  desc: 'Selección, motivación, liderazgo y gestión del talento.'
}, {
  icon: <CalculatorIcon className="w-6 h-6 text-primary" data-id="element-69" />,
  title: 'Contabilidad y Finanzas',
  desc: 'Estados contables básicos, presupuestos y análisis financiero.'
}, {
  icon: <TrendingUpIcon className="w-6 h-6 text-primary" data-id="element-70" />,
  title: 'Marketing y Ventas',
  desc: 'Mix de marketing, investigación de mercado y estrategias de venta.'
}, {
  icon: <TruckIcon className="w-6 h-6 text-primary" data-id="element-71" />,
  title: 'Operaciones y Logística',
  desc: 'Gestión de la producción, cadena de suministro y calidad.'
}, {
  icon: <HeartHandshakeIcon className="w-6 h-6 text-primary" data-id="element-72" />,
  title: 'Responsabilidad Social Corporativa',
  desc: 'Ética empresarial, impacto ambiental y social de las organizaciones.'
}, {
  icon: <LandmarkIcon className="w-6 h-6 text-primary" data-id="element-73" />,
  title: 'El Rol del Estado en la Economía',
  desc: 'Políticas públicas, impuestos y regulaciones empresariales.'
}];
export function Modules() {
  return <section className="py-24 bg-white" data-id="element-74">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-75">
        <motion.div initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4
      }} className="text-center mb-16" data-id="element-76">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-77">
            Contenido Completo por Unidad Temática
          </h2>
          <div className="w-24 h-1 bg-primary mx-auto rounded-full" data-id="element-78" />
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-79">
          {modules.map((mod, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.35,
          delay: index * 0.05
        }} className="bg-gray-50 rounded-xl p-6 border-t-4 border-primary shadow-sm hover:shadow-md transition-shadow" data-id="element-80">
              <div className="bg-white w-12 h-12 rounded-full flex items-center justify-center shadow-sm mb-4" data-id="element-81">
                {mod.icon}
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-82">
                {mod.title}
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed" data-id="element-83">
                {mod.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}